export const UMB_USER_COLLECTION_ALIAS = 'Umb.Collection.User';
